// Google Analytics 4 integration point. Nothing loads until BOTH conditions are met:
//  1) GA_MEASUREMENT_ID is set in src/config.js (owner supplies it), and
//  2) the visitor has granted consent (call grantAnalyticsConsent() from your consent banner).
import { GA_MEASUREMENT_ID } from "./config";

const KEY = "fc-analytics-consent";
let loaded = false;

const hasConsent = () => {
  try {
    return window.localStorage.getItem(KEY) === "granted";
  } catch (e) {
    return false;
  }
};

export function initAnalytics() {
  if (loaded || !GA_MEASUREMENT_ID || !hasConsent()) return;
  if (document.querySelector('script[data-ga="1"]')) return;
  const s = document.createElement("script");
  s.async = true;
  s.src = "https://www.googletagmanager.com/gtag/js?id=" + encodeURIComponent(GA_MEASUREMENT_ID);
  s.setAttribute("data-ga", "1");
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", GA_MEASUREMENT_ID, { send_page_view: false });
  loaded = true;
}

export function trackPageView(path) {
  if (!loaded || !window.gtag) return;
  window.gtag("event", "page_view", { page_path: path, page_title: document.title });
}

export function grantAnalyticsConsent() {
  try {
    window.localStorage.setItem(KEY, "granted");
  } catch (e) {
    /* ignore */
  }
  initAnalytics();
}
